import { Coach } from '../components/CoachCard'

export const coaches: Coach[] = [
  {
    id: '1',
    name: 'Donna Kellogg',
    role: 'Lead Coach',
    credentials: 'BSc (Hons) MBE OLY',
    image:
      'https://cdn.magicpatterns.com/uploads/4ASxFGF7ivucC7XtmD1BzK/donna_pic_cropped-768x767.webp',
    bio: 'Triple Olympian who represented Team GB at the 2000, 2004 and 2008 Olympic Games. Multiple world, Commonwealth and European championship medallist.',
    fullBio:
      "Donna is a fantastic sporting role model for all our Bright Star Sports children. She is a triple Olympian having represented Team GB at the 2000, 2004 and 2008 Olympic Games and is a multiple world, Commonwealth and European championship medallist. Donna has loved her life in sport and hopes to inspire more young children to have fun, build their confidence and value the friendships they make whilst participating in sport and physical activity.\n\nShe has coached all ages and abilities over the years having been involved with school programmes, holiday camps and coaching workshops. Donna's two young daughters enjoy trying out the latest content in our Bright Star Sports sessions and give Mum plenty of feedback.",
    achievements: [
      'Triple Olympian (2000, 2004, 2008)',
      'Multiple World Championship Medallist',
      'Commonwealth Championship Medallist',
      'European Championship Medallist',
      'Awarded MBE',
    ],
    philosophy:
      'I hope to inspire more young children to have fun, build their confidence and value the friendships they make whilst participating in sport and physical activity.',
  },
  {
    id: '2',
    name: 'Natalie Barton',
    role: 'Lead Coach',
    credentials: 'BSc (Hons) OLY',
    image:
      'https://cdn.magicpatterns.com/uploads/ocRMerKbd1woFGMKYSm6JS/natalie_pic_cropped-768x767.webp',
    bio: "Multi-talented sportswoman who represented Team GB at the 2004 Olympic Games. Former international badminton player with a career-high ranking inside the world's top 5.",
    fullBio:
      "Natalie is a multi-talented sportswoman having competed in many sports to a high level and represented Team GB at the 2004 Olympic Games. She is a former international badminton player with a career-high ranking inside the world's top 5 and still enjoys competing for Hertfordshire in the Inter Counties Premiership.\n\nNatalie is a highly accomplished PE teacher, delivering a full curriculum of sports to children aged 3 to 18. She ensures all Bright Star Sports workshops and classes create a supportive and fun environment where children can come and explore new sports, learn new skills and be inspired and encouraged to achieve their goals.",
    achievements: [
      'Olympic Games Representative (2004)',
      'World Top 5 Ranking',
      'Inter Counties Premiership Competitor',
      'Accomplished PE Teacher',
    ],
    philosophy:
      'Creating a supportive and fun environment where children can explore new sports, learn new skills and be inspired and encouraged to achieve their goals.',
  },
  {
    id: '3',
    name: 'Sarah Chapman',
    role: 'Lead Coach',
    credentials: 'MSc BSc (Hons) OLY',
    image:
      'https://cdn.magicpatterns.com/uploads/pQyrJ9Go8cTY1DPUpopDaC/sarah_chapman_cropped-768x767.webp',
    bio: 'Team GB Olympic star who competed at the Sydney 2000 Olympic Games. European championship medallist with a career-high ranking inside the world top 10.',
    fullBio:
      'Sarah is another of our Team GB Olympic stars and competed at the Sydney 2000 Olympic Games. She is a European championship medallist, won multiple international badminton tournaments and achieved a career-high ranking inside the world top 10.\n\nShe has worked for the past 20 years as a musculoskeletal physiotherapist and uses her rehab and strength and conditioning knowledge to build badminton-specific speed, strength and stability skills in young athletes.\n\nSarah is a Badminton England UKCC Level 2 Coach and has many years of badminton coaching experience from beginners through to county-level and junior international players.',
    achievements: [
      'Olympic Games Representative (Sydney 2000)',
      'European Championship Medallist',
      'World Top 10 Ranking',
      'Badminton England UKCC Level 2 Coach',
      'Musculoskeletal Physiotherapist',
    ],
    philosophy:
      'Using rehab and strength and conditioning knowledge to build badminton-specific speed, strength and stability skills in young athletes.',
  },
]
